import type { SurfaceEntry } from '@/lib/sync/document-surfaces';
import { isTerminal, type PendingRun } from '@/stores/use-template-run-store';

export function placeholderFor(
  run: PendingRun,
  entries: readonly SurfaceEntry[],
  claimed: ReadonlySet<string | null>,
): SurfaceEntry | undefined {
  if (run.surfaceId !== null || isTerminal(run.stage)) return undefined;
  return entries.find((e) =>
    !run.knownSurfaceIds.includes(e.id) && e.generator === run.templateId && !claimed.has(e.id));
}

// Decided in render rather than after linking, so a placeholder and its
// Starting row are never painted together.
export function runsAwaitingSurface(
  runs: readonly PendingRun[],
  entries: readonly SurfaceEntry[],
): PendingRun[] {
  const claimed = new Set<string | null>(runs.map((run) => run.surfaceId));
  return runs.filter((run) => {
    if (isTerminal(run.stage)) {
      return run.surfaceId === null && (run.stage === 'failed' || run.stage === 'cancelled');
    }
    if (run.surfaceId !== null) return !entries.some((e) => e.id === run.surfaceId);
    const placeholder = placeholderFor(run, entries, claimed);
    if (!placeholder) return true;
    claimed.add(placeholder.id);
    return false;
  });
}
